import React from "react";
import { useClasses } from "@api/class.api";
import { RuleTagRow } from "../RuleTagRow";

interface Props {
    value: string[];
}

export const RuleClassesAction: React.FC<Props> = ({ value }) => {
    const { classesMap } = useClasses();

    const classLabels = value
        .map((id) => classesMap.get(id)?.label)
        .filter((label): label is string => label !== undefined);

    if (!classLabels.length) {
        return null;
    }

    return (
        <RuleTagRow label="Assign class" type="action" values={classLabels} />
    );
};
